var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans app_top_image"},[_c('router-view',{attrs:{"id":"app"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }